// removed by extract-text-webpack-plugin
module.exports = {"center":"_3BxRa","justify":"_2OIdO","right":"ih-I8"};


//////////////////
// WEBPACK FOOTER
// ./app/components/styled-text-editor/text-alignment-theme.scss
// module id = 820
// module chunks = 3 4 5 6 7